import { Download } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { exportUsageAsCsv, exportUsageAsJson } from '@/routes/usage/utils'
import type { UsageGroup } from '@/routes/usage/types'

type UsageTableActionsProps = {
  groups: UsageGroup[]
  periodLabel: string
}

export const UsageTableActions = ({
  groups,
  periodLabel,
}: UsageTableActionsProps) => {
  const slug = periodLabel.toLowerCase().replace(/\s/g, '-')
  const isEmpty = groups.every((g) => g.gross === 0)

  const handleExportCsv = () => {
    exportUsageAsCsv({ groups, filename: `usage-${slug}.csv` })
  }

  const handleExportJson = () => {
    exportUsageAsJson({ groups, filename: `usage-${slug}.json` })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-9 gap-1.5 text-sm"
          disabled={isEmpty}
        >
          <Download className="size-3.5" />
          Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleExportCsv}>
          Export as CSV
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleExportJson}>
          Export as JSON
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
